import React from 'react';
export const PrivacyPolicy = () => {
  return <div className="pt-20" data-id="element-4399">
      <section className="py-16 bg-secondary/5" data-id="element-4400">
        <div className="container mx-auto px-4" data-id="element-4401">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4402">
            Privacy Policy
          </h1>
          <p className="text-center text-secondary" data-id="element-4403">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-4404">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-4405">
          <div className="prose prose-lg max-w-none" data-id="element-4406">
            <p data-id="element-4407">
              The Networking Salon ("we," "our," or "us") values your trust.
              This Privacy Policy explains how we collect, use, and protect your
              information when you engage with our website, events, and
              community.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4408">
              1. Information We Collect
            </h2>
            <p data-id="element-4409">When you interact with The Networking Salon, we may collect:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4410">
              <li data-id="element-4411">
                <strong data-id="element-4412">Personal Information:</strong> Name, email, phone
                number, company, role/title, and other details you share when
                registering for events, subscribing to updates, or filling out
                forms.
              </li>
              <li data-id="element-4413">
                <strong data-id="element-4414">Community Information:</strong> If you join our network,
                we may collect details you provide about your professional
                background, interests, and connections.
              </li>
              <li data-id="element-4415">
                <strong data-id="element-4416">Website Data:</strong> IP address, browser type, pages
                visited, and time spent on our site.
              </li>
              <li data-id="element-4417">
                <strong data-id="element-4418">Cookies:</strong> Small files that help us improve your
                experience and track engagement.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4419">
              2. How We Use Your Information
            </h2>
            <p data-id="element-4420">We use your information to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4421">
              <li data-id="element-4422">Register you for events and send confirmations/updates.</li>
              <li data-id="element-4423">
                Share relevant communications such as newsletters, networking
                opportunities, or event invitations.
              </li>
              <li data-id="element-4424">
                Improve the quality of our website, community, and events.
              </li>
              <li data-id="element-4425">
                Build stronger connections between members of our network.
              </li>
              <li data-id="element-4426">Ensure compliance with legal and security requirements.</li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4427">
              3. Sharing Your Information
            </h2>
            <p data-id="element-4428">
              We respect your privacy. Your information is never sold. We may
              only share your information with:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4429">
              <li data-id="element-4430">
                <strong data-id="element-4431">Event & Service Partners:</strong> Trusted providers
                (e.g., venues, ticketing, email platforms) necessary to deliver
                our services.
              </li>
              <li data-id="element-4432">
                <strong data-id="element-4433">Community Connections:</strong> With your consent, we
                may share limited professional information to foster
                introductions within our network.
              </li>
              <li data-id="element-4434">
                <strong data-id="element-4435">Legal Obligations:</strong> When required by law or to
                protect our rights and community.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4436">
              4. Cookies & Tracking
            </h2>
            <p data-id="element-4437">We use cookies to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4438">
              <li data-id="element-4439">Remember your preferences.</li>
              <li data-id="element-4440">Understand how people use our site.</li>
              <li data-id="element-4441">Improve our content and event promotion.</li>
            </ul>
            <p data-id="element-4442">You can manage cookies through your browser settings.</p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4443">5. Data Retention</h2>
            <p data-id="element-4444">
              We keep your information only as long as needed to provide
              services, manage community relationships, or comply with legal
              obligations.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4445">6. Your Rights</h2>
            <p data-id="element-4446">Depending on your location, you may have rights such as:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4447">
              <li data-id="element-4448">Accessing or updating your information.</li>
              <li data-id="element-4449">Requesting deletion of your data.</li>
              <li data-id="element-4450">Opting out of marketing communications at any time.</li>
              <li data-id="element-4451">Restricting certain uses of your personal information.</li>
            </ul>
            <p data-id="element-4452">
              To exercise these rights, email us at:
              thenetworkingsalon@gmail.com
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4453">7. Security</h2>
            <p data-id="element-4454">
              We use reasonable safeguards to protect your information. However,
              no online transmission is completely secure, so we encourage you
              to take care when sharing information.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4455">
              8. Third-Party Links
            </h2>
            <p data-id="element-4456">
              The Networking Salon may link to external sites (e.g., partners,
              event platforms). We are not responsible for their privacy
              practices.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4457">9. Policy Updates</h2>
            <p data-id="element-4458">
              We may update this Privacy Policy occasionally. Updates will be
              posted on this page with the latest revision date.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4459">10. Contact Us</h2>
            <p data-id="element-4460">
              If you have questions about this Privacy Policy or how we handle
              your information, please reach out:
            </p>
            <p data-id="element-4461">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-4462">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};